export default function createDocument(data) {
	return data.ref.set(data);
}
